// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"706":"8789c5dd","787":"3a9ce6f3"}[chunkId] + ".chunk.js";
};